module.exports = __webpack_public_path__ + "img/1f996.8896f11.svg";